import axios from 'axios';
import queryString from 'query-string';
import actions from '../actions/bestList';

export default {
	namespaced: true,
	state: {
		entities: [],
		links: [],
		paginationMetadata: {},
	},
	mutations: {
		[actions.SET_DATA]: (state, data) => {
			state.links = data.links;
			state.entities = data.entities;
			state.paginationMetadata = data.paginationMetadata;
		},
		[actions.SET_LINKS]: (state, data) => {
			state.links = data.links;
		},
		[actions.REMOVE_DATA]: (state) => {
			state.links = [];
			state.entities = [];
			state.paginationMetadata = {};
		},
	},
	actions: {
		[actions.GET_PERFORMANCELIST_LINKS]: async ({ commit, rootState }) => {
			try {
				const link = rootState.root.links.find(x => x.rel === 'perf_list_links' && x.templated);

				const response = await axios.get(link.href);

				const { data } = response;

				commit(actions.SET_LINKS, data);
			} catch (error) {
				throw error;
			}
		},
		[actions.GET_BEST_LISTS]: async (
			{ commit, rootState },
			{ masterOrgId, queryParameters }) => {
			try {
				commit(actions.REMOVE_DATA);

				const link = rootState.root.links.find(x => x.rel === 'perf_lists' && x.templated);

				const queryTemplatePos = link.href.indexOf('{?');
				const queryTemplate = link.href.substring(queryTemplatePos, link.href.length);

				const href = link.href
					.replace('{masterOrgId}', masterOrgId)
					.replace(queryTemplate, `?${queryString.stringify(queryParameters)}`);

				const response = await axios.get(href);

				const { data } = response;

				data.entities.forEach((entity) => {
					entity.id = `${entity.id}`;
				});

				commit(actions.SET_DATA, data);
			} catch (error) {
				throw error;
			}
		},
		[actions.FULL_UPDATE_BESTLIST]: async (context, { bestList, link }) => {
			try {
				await axios.put(link.href, bestList);
			} catch (error) {
				throw error;
			}
		},
		[actions.FETCH_BEST_LISTS]: async ({ commit }, link) => {
			try {
				commit(actions.REMOVE_DATA);

				const response = await axios.get(link.href);

				const { data } = response;

				data.entities.forEach((entity) => {
					entity.id = `${entity.id}`;
				});

				commit(actions.SET_DATA, data);
			} catch (error) {
				throw error;
			}
		},
		[actions.CREATE_NEW_BEST_LIST]: async (context, { bestList, link }) => {
			try {
				const response = await axios.post(link.href, bestList);
				const { data } = response;
				return data;
			} catch (error) {
				throw error;
			}
		},
		// [actions.DELETE_BEST_LIST]: async (context, { href }) => {
		// 	try {
		// 		await axios.delete(href);
		// 	} catch (error) {
		// 		throw error;
		// 	}
		// },
		[actions.GET_BRANCHES_FOR_PERFDB]: async ({ rootState }, id) => {
			let organizations = [];

			try {
				const link = rootState.root.links
					.find(x => x.rel === 'perf_org' && x.templated);

				const href = link.href
					.replace('{id}', id);

				const response = await axios.get(href);

				const { data } = response;

				organizations = data;
			} catch (error) {
				throw error;
			}

			return organizations;
		},
		[actions.GET_BRANCH_BY_NAME_AND_MASTERID]: async ({ rootState }, { id, name }) => {
			let organizations = [];

			try {
				const link = rootState.root.links
					.find(x => x.rel === 'get_org_by_name_id');

				const href = link.href
					.replace('{id}', id)
					.replace('{name}', name);

				const response = await axios.get(href);

				const { data } = response;

				organizations = data;
			} catch (error) {
				throw error;
			}

			return organizations;
		},
		[actions.GET_FILTERED_BRANCHES_FOR_PERFDB]: async ({ rootState }, { id, query }) => {
			let organizations = [];

			try {
				const link = rootState.root.links
					.find(x => x.rel === 'perf_filter_org' && x.templated);

				const href = link.href
					.replace('{id}', id)
					.replace('{query}', query);

				const response = await axios.get(href);

				const { data } = response;

				organizations = data;
			} catch (error) {
				throw error;
			}

			return organizations;
		},
		[actions.GET_BEST_LISTS_FOR_SELECTOR]: async ({ rootState }, organizationId) => {
			let perfLists = [];

			try {
				const link = rootState.root.links
					.find(x => x.rel === 'perf_list_for_selectors' && x.templated);

				const href = link.href
					.replace('{masterOrgId}', organizationId);

				const response = await axios.get(href);

				const { data } = response;

				perfLists = data;
			} catch (error) {
				throw error;
			}

			return perfLists;
		},
		[actions.GET_BESTLIST_BY_ID]: async ({ rootState }, id) => {
			try {
				const link = rootState.root.links.find(x => x.rel === 'perf_list' && x.templated);

				const href = link.href
					.replace('{id}', id);

				const response = await axios.get(href);

				const { data } = response;

				return data;
			} catch (error) {
				throw error;
			}
		},
		[actions.CREATE_DLO_DEFS]: async (context, { link, targetId }) => {
			try {
				const href = link.href
					.replace('{targetPerformanceListId}', targetId);
				await axios.post(href);
			} catch (error) {
				throw error;
			}
		},
		[actions.COPY_DEF_FROM_EXISTING]: async (context, { link, srcId, targetId }) => {
			try {
				const href = link.href
					.replace('{sourcePerformanceListId}', srcId)
					.replace('{targetPerformanceListId}', targetId);
				await axios.post(href);
			} catch (error) {
				throw error;
			}
		},
		[actions.CREATE_EVENT_CLASS]: async (context, { link, payload }) => {
			try {
				await axios.post(link.href, payload);
			} catch (error) {
				throw error;
			}
		},
		[actions.CREATE_EVENT_CLASS_ARRAY]: async (context, { link, payload }) => {
			try {
				await axios.post(link.href, payload);
			} catch (error) {
				throw error;
			}
		},
		[actions.GET_CUSTOM_DEFS]: async (context, { href }) => {
			try {
				const response = await axios.get(href);
				const { data } = response;
				return data.entities;
			} catch (error) {
				throw error;
			}
		},
		[actions.UPDATE_CUSTOM_DEF]: async (context, { link, payload }) => {
			try {
				await axios.put(link.href, payload);
			} catch (error) {
				throw error;
			}
		},
	},
	getters: {
		Entities: state => state.entities,
		Links: state => state.links,
		Pagination: state => state.paginationMetadata,
	},
};
